import React, { useRef, useState } from "react";
import "./ImageFileSelect.scss";

const ImageFileSelect = ({ filePreviewURL, updateFile }) => {
  const fileInputRef = useRef();

  // Track which URL had an error, rather than just a boolean
  // This automatically resets when filePreviewURL changes (no useEffect needed)
  const [erroredURL, setErroredURL] = useState(null);
  const markMediaError = () => setErroredURL(filePreviewURL);
  const mediaError = erroredURL === filePreviewURL;

  const showFileSelector = () => fileInputRef?.current?.click();

  if (filePreviewURL && !mediaError) {
    return (
      <div className="artwork-file-select">
        <img
          className="file-upload-preview"
          src={filePreviewURL}
          alt="Preview for newly uploaded album artwork"
          onClick={showFileSelector}
          onError={markMediaError}
        />
        <input ref={fileInputRef} type="file" className="hidden-file-input" onChange={updateFile} />
      </div>
    );
  }

  return (
    <div className="artwork-file-select">
      <div className="file-upload-zone" onClick={showFileSelector}>
        <div className="file-upload-zone-inner">
          <div className="file-upload-zone-label">Drop file here or click to upload</div>
        </div>
      </div>
      <input ref={fileInputRef} type="file" className="hidden-file-input" onChange={updateFile} />
    </div>
  );
};

export default ImageFileSelect;
